import * as ambassadorWixBookingsStaffV1StaffMember from './bookings-staff-v1-staff-member-staff-members.http.js';
import * as ambassadorWixBookingsStaffV1StaffMemberTypes from './bookings-staff-v1-staff-member-staff-members.types.js';
import * as ambassadorWixBookingsStaffV1StaffMemberUniversalTypes from './bookings-staff-v1-staff-member-staff-members.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createStaffMember(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBookingsStaffV1StaffMemberUniversalTypes.CreateStaffMemberRequest,
  ambassadorWixBookingsStaffV1StaffMemberTypes.CreateStaffMemberRequest,
  ambassadorWixBookingsStaffV1StaffMemberUniversalTypes.CreateStaffMemberResponse,
  ambassadorWixBookingsStaffV1StaffMemberTypes.CreateStaffMemberResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBookingsStaffV1StaffMember.createStaffMember(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/staff-members',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getStaffMember(): __PublicMethodMetaInfo<
  'GET',
  { staffMemberId: string },
  ambassadorWixBookingsStaffV1StaffMemberUniversalTypes.GetStaffMemberRequest,
  ambassadorWixBookingsStaffV1StaffMemberTypes.GetStaffMemberRequest,
  ambassadorWixBookingsStaffV1StaffMemberUniversalTypes.GetStaffMemberResponse,
  ambassadorWixBookingsStaffV1StaffMemberTypes.GetStaffMemberResponse
> {
  const payload = { staffMemberId: ':staffMemberId' } as any;

  const getRequestOptions =
    ambassadorWixBookingsStaffV1StaffMember.getStaffMember(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/staff-members/{staffMemberId}',
    pathParams: { staffMemberId: 'staffMemberId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getDeletedStaffMember(): __PublicMethodMetaInfo<
  'GET',
  { staffMemberId: string },
  ambassadorWixBookingsStaffV1StaffMemberUniversalTypes.GetDeletedStaffMemberRequest,
  ambassadorWixBookingsStaffV1StaffMemberTypes.GetDeletedStaffMemberRequest,
  ambassadorWixBookingsStaffV1StaffMemberUniversalTypes.GetDeletedStaffMemberResponse,
  ambassadorWixBookingsStaffV1StaffMemberTypes.GetDeletedStaffMemberResponse
> {
  const payload = { staffMemberId: ':staffMemberId' } as any;

  const getRequestOptions =
    ambassadorWixBookingsStaffV1StaffMember.getDeletedStaffMember(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v2/staff-members/trash-bin/{staffMemberId}',
    pathParams: { staffMemberId: 'staffMemberId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listDeletedStaffMembers(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixBookingsStaffV1StaffMemberUniversalTypes.ListDeletedStaffMembersRequest,
  ambassadorWixBookingsStaffV1StaffMemberTypes.ListDeletedStaffMembersRequest,
  ambassadorWixBookingsStaffV1StaffMemberUniversalTypes.ListDeletedStaffMembersResponse,
  ambassadorWixBookingsStaffV1StaffMemberTypes.ListDeletedStaffMembersResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBookingsStaffV1StaffMember.listDeletedStaffMembers(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v2/staff-members/trash-bin',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function removeStaffMemberFromTrashBin(): __PublicMethodMetaInfo<
  'DELETE',
  { staffMemberId: string },
  ambassadorWixBookingsStaffV1StaffMemberUniversalTypes.RemoveStaffMemberFromTrashBinRequest,
  ambassadorWixBookingsStaffV1StaffMemberTypes.RemoveStaffMemberFromTrashBinRequest,
  ambassadorWixBookingsStaffV1StaffMemberUniversalTypes.RemoveStaffMemberFromTrashBinResponse,
  ambassadorWixBookingsStaffV1StaffMemberTypes.RemoveStaffMemberFromTrashBinResponse
> {
  const payload = { staffMemberId: ':staffMemberId' } as any;

  const getRequestOptions =
    ambassadorWixBookingsStaffV1StaffMember.removeStaffMemberFromTrashBin(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v2/staff-members/trash-bin/{staffMemberId}',
    pathParams: { staffMemberId: 'staffMemberId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateStaffMember(): __PublicMethodMetaInfo<
  'PATCH',
  { staffMemberId: string },
  ambassadorWixBookingsStaffV1StaffMemberUniversalTypes.UpdateStaffMemberRequest,
  ambassadorWixBookingsStaffV1StaffMemberTypes.UpdateStaffMemberRequest,
  ambassadorWixBookingsStaffV1StaffMemberUniversalTypes.UpdateStaffMemberResponse,
  ambassadorWixBookingsStaffV1StaffMemberTypes.UpdateStaffMemberResponse
> {
  const payload = { staffMember: { id: ':staffMemberId' } } as any;

  const getRequestOptions =
    ambassadorWixBookingsStaffV1StaffMember.updateStaffMember(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/staff-members/{staffMember.id}',
    pathParams: { staffMemberId: 'staffMemberId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteStaffMember(): __PublicMethodMetaInfo<
  'DELETE',
  { staffMemberId: string },
  ambassadorWixBookingsStaffV1StaffMemberUniversalTypes.DeleteStaffMemberRequest,
  ambassadorWixBookingsStaffV1StaffMemberTypes.DeleteStaffMemberRequest,
  ambassadorWixBookingsStaffV1StaffMemberUniversalTypes.DeleteStaffMemberResponse,
  ambassadorWixBookingsStaffV1StaffMemberTypes.DeleteStaffMemberResponse
> {
  const payload = { staffMemberId: ':staffMemberId' } as any;

  const getRequestOptions =
    ambassadorWixBookingsStaffV1StaffMember.deleteStaffMember(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/staff-members/{staffMemberId}',
    pathParams: { staffMemberId: 'staffMemberId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryStaffMembers(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBookingsStaffV1StaffMemberUniversalTypes.QueryStaffMembersRequest,
  ambassadorWixBookingsStaffV1StaffMemberTypes.QueryStaffMembersRequest,
  ambassadorWixBookingsStaffV1StaffMemberUniversalTypes.QueryStaffMembersResponse,
  ambassadorWixBookingsStaffV1StaffMemberTypes.QueryStaffMembersResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBookingsStaffV1StaffMember.queryStaffMembers(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/staff-members/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function countStaffMembers(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBookingsStaffV1StaffMemberUniversalTypes.CountStaffMembersRequest,
  ambassadorWixBookingsStaffV1StaffMemberTypes.CountStaffMembersRequest,
  ambassadorWixBookingsStaffV1StaffMemberUniversalTypes.CountStaffMembersResponse,
  ambassadorWixBookingsStaffV1StaffMemberTypes.CountStaffMembersResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBookingsStaffV1StaffMember.countStaffMembers(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/staff-members/count',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function connectStaffMemberToUser(): __PublicMethodMetaInfo<
  'POST',
  { staffMemberId: string },
  ambassadorWixBookingsStaffV1StaffMemberUniversalTypes.ConnectStaffMemberToUserRequest,
  ambassadorWixBookingsStaffV1StaffMemberTypes.ConnectStaffMemberToUserRequest,
  ambassadorWixBookingsStaffV1StaffMemberUniversalTypes.ConnectStaffMemberToUserResponse,
  ambassadorWixBookingsStaffV1StaffMemberTypes.ConnectStaffMemberToUserResponse
> {
  const payload = { staffMemberId: ':staffMemberId' } as any;

  const getRequestOptions =
    ambassadorWixBookingsStaffV1StaffMember.connectStaffMemberToUser(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/staff-members/{staffMemberId}/connect-staff-member-to-user',
    pathParams: { staffMemberId: 'staffMemberId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function searchStaffMembers(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBookingsStaffV1StaffMemberUniversalTypes.SearchStaffMembersRequest,
  ambassadorWixBookingsStaffV1StaffMemberTypes.SearchStaffMembersRequest,
  ambassadorWixBookingsStaffV1StaffMemberUniversalTypes.SearchStaffMembersResponse,
  ambassadorWixBookingsStaffV1StaffMemberTypes.SearchStaffMembersResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBookingsStaffV1StaffMember.searchStaffMembers(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/staff-members/search',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function disconnectStaffMemberFromUser(): __PublicMethodMetaInfo<
  'POST',
  { staffMemberId: string },
  ambassadorWixBookingsStaffV1StaffMemberUniversalTypes.DisconnectStaffMemberFromUserRequest,
  ambassadorWixBookingsStaffV1StaffMemberTypes.DisconnectStaffMemberFromUserRequest,
  ambassadorWixBookingsStaffV1StaffMemberUniversalTypes.DisconnectStaffMemberFromUserResponse,
  ambassadorWixBookingsStaffV1StaffMemberTypes.DisconnectStaffMemberFromUserResponse
> {
  const payload = { staffMemberId: ':staffMemberId' } as any;

  const getRequestOptions =
    ambassadorWixBookingsStaffV1StaffMember.disconnectStaffMemberFromUser(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/staff-members/{staffMemberId}/disconnect-staff-member-from-user',
    pathParams: { staffMemberId: 'staffMemberId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function assignWorkingHoursSchedule(): __PublicMethodMetaInfo<
  'POST',
  { staffMemberId: string },
  ambassadorWixBookingsStaffV1StaffMemberUniversalTypes.AssignWorkingHoursScheduleRequest,
  ambassadorWixBookingsStaffV1StaffMemberTypes.AssignWorkingHoursScheduleRequest,
  ambassadorWixBookingsStaffV1StaffMemberUniversalTypes.AssignWorkingHoursScheduleResponse,
  ambassadorWixBookingsStaffV1StaffMemberTypes.AssignWorkingHoursScheduleResponse
> {
  const payload = { staffMemberId: ':staffMemberId' } as any;

  const getRequestOptions =
    ambassadorWixBookingsStaffV1StaffMember.assignWorkingHoursSchedule(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/staff-members/{staffMemberId}/assign-working-hours-schedule',
    pathParams: { staffMemberId: 'staffMemberId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function assignCustomSchedule(): __PublicMethodMetaInfo<
  'POST',
  { staffMemberId: string },
  ambassadorWixBookingsStaffV1StaffMemberUniversalTypes.AssignCustomScheduleRequest,
  ambassadorWixBookingsStaffV1StaffMemberTypes.AssignCustomScheduleRequest,
  ambassadorWixBookingsStaffV1StaffMemberUniversalTypes.AssignCustomScheduleResponse,
  ambassadorWixBookingsStaffV1StaffMemberTypes.AssignCustomScheduleResponse
> {
  const payload = { staffMemberId: ':staffMemberId' } as any;

  const getRequestOptions =
    ambassadorWixBookingsStaffV1StaffMember.assignCustomSchedule(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/staff-members/{staffMemberId}/assign-custom-schedule',
    pathParams: { staffMemberId: 'staffMemberId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateStaffMemberTags(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBookingsStaffV1StaffMemberUniversalTypes.BulkUpdateStaffMemberTagsRequest,
  ambassadorWixBookingsStaffV1StaffMemberTypes.BulkUpdateStaffMemberTagsRequest,
  ambassadorWixBookingsStaffV1StaffMemberUniversalTypes.BulkUpdateStaffMemberTagsResponse,
  ambassadorWixBookingsStaffV1StaffMemberTypes.BulkUpdateStaffMemberTagsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBookingsStaffV1StaffMember.bulkUpdateStaffMemberTags(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/staff-members/update-tags',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateStaffMemberTagsByFilter(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBookingsStaffV1StaffMemberUniversalTypes.BulkUpdateStaffMemberTagsByFilterRequest,
  ambassadorWixBookingsStaffV1StaffMemberTypes.BulkUpdateStaffMemberTagsByFilterRequest,
  ambassadorWixBookingsStaffV1StaffMemberUniversalTypes.BulkUpdateStaffMemberTagsByFilterResponse,
  ambassadorWixBookingsStaffV1StaffMemberTypes.BulkUpdateStaffMemberTagsByFilterResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBookingsStaffV1StaffMember.bulkUpdateStaffMemberTagsByFilter(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/staff-members/update-tags-by-filter',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  StaffMember as StaffMemberOriginal,
  MediaItem as MediaItemOriginal,
  MediaItemMediaOneOf as MediaItemMediaOneOfOriginal,
  Image as ImageOriginal,
  Resource as ResourceOriginal,
  WorkingHoursSchedule as WorkingHoursScheduleOriginal,
  EventSchedule as EventScheduleOriginal,
  LocationOptions as LocationOptionsOriginal,
  SpecificLocation as SpecificLocationOriginal,
  BusinessLocation as BusinessLocationOriginal,
  AssociatedWixIdentity as AssociatedWixIdentityOriginal,
  CommonIdentificationData as CommonIdentificationDataOriginal,
  CommonIdentificationDataIdOneOf as CommonIdentificationDataIdOneOfOriginal,
  IdentityType as IdentityTypeOriginal,
  IdentityTypeWithLiterals as IdentityTypeWithLiteralsOriginal,
  AssociatedWixIdentityConnectionStatusEnumConnectionStatus as AssociatedWixIdentityConnectionStatusEnumConnectionStatusOriginal,
  AssociatedWixIdentityConnectionStatusEnumConnectionStatusWithLiterals as AssociatedWixIdentityConnectionStatusEnumConnectionStatusWithLiteralsOriginal,
  Connection as ConnectionOriginal,
  AssociatedConferencingProviders as AssociatedConferencingProvidersOriginal,
  AssociatedConferencingProvider as AssociatedConferencingProviderOriginal,
  ConnectionStatus as ConnectionStatusOriginal,
  ConnectionStatusWithLiterals as ConnectionStatusWithLiteralsOriginal,
  AssociatedConferencingAccounts as AssociatedConferencingAccountsOriginal,
  AssociatedConferencingAccount as AssociatedConferencingAccountOriginal,
  AssociatedConferencingAccountAccountOneOf as AssociatedConferencingAccountAccountOneOfOriginal,
  CustomConferenceAccount as CustomConferenceAccountOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  Tags as TagsOriginal,
  TagList as TagListOriginal,
  Gender as GenderOriginal,
  GenderWithLiterals as GenderWithLiteralsOriginal,
  StaffMemberDisconnectedFromUser as StaffMemberDisconnectedFromUserOriginal,
  StaffMemberConnectedToUser as StaffMemberConnectedToUserOriginal,
  StaffMemberFullyCreated as StaffMemberFullyCreatedOriginal,
  TagsModified as TagsModifiedOriginal,
  CreateStaffMemberRequest as CreateStaffMemberRequestOriginal,
  RequestedFields as RequestedFieldsOriginal,
  RequestedFieldsWithLiterals as RequestedFieldsWithLiteralsOriginal,
  CreateStaffMemberResponse as CreateStaffMemberResponseOriginal,
  GetStaffMemberRequest as GetStaffMemberRequestOriginal,
  GetStaffMemberResponse as GetStaffMemberResponseOriginal,
  GetDeletedStaffMemberRequest as GetDeletedStaffMemberRequestOriginal,
  GetDeletedStaffMemberResponse as GetDeletedStaffMemberResponseOriginal,
  ListDeletedStaffMembersRequest as ListDeletedStaffMembersRequestOriginal,
  CursorPaging as CursorPagingOriginal,
  ListDeletedStaffMembersResponse as ListDeletedStaffMembersResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  RemoveStaffMemberFromTrashBinRequest as RemoveStaffMemberFromTrashBinRequestOriginal,
  RemoveStaffMemberFromTrashBinResponse as RemoveStaffMemberFromTrashBinResponseOriginal,
  RestoreStaffMemberFromTrashBinRequest as RestoreStaffMemberFromTrashBinRequestOriginal,
  RestoreStaffMemberFromTrashBinResponse as RestoreStaffMemberFromTrashBinResponseOriginal,
  UpdateStaffMemberRequest as UpdateStaffMemberRequestOriginal,
  UpdateStaffMemberResponse as UpdateStaffMemberResponseOriginal,
  DeleteStaffMemberRequest as DeleteStaffMemberRequestOriginal,
  DeleteStaffMemberResponse as DeleteStaffMemberResponseOriginal,
  QueryStaffMembersRequest as QueryStaffMembersRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  QueryStaffMembersResponse as QueryStaffMembersResponseOriginal,
  QueryStaffMembersMultiLanguageRequest as QueryStaffMembersMultiLanguageRequestOriginal,
  QueryStaffMembersMultiLanguageResponse as QueryStaffMembersMultiLanguageResponseOriginal,
  CountStaffMembersRequest as CountStaffMembersRequestOriginal,
  CountStaffMembersResponse as CountStaffMembersResponseOriginal,
  ConnectStaffMemberToUserRequest as ConnectStaffMemberToUserRequestOriginal,
  ConnectStaffMemberToUserResponse as ConnectStaffMemberToUserResponseOriginal,
  SearchStaffMembersRequest as SearchStaffMembersRequestOriginal,
  CursorSearch as CursorSearchOriginal,
  CursorSearchPagingMethodOneOf as CursorSearchPagingMethodOneOfOriginal,
  SearchDetails as SearchDetailsOriginal,
  Mode as ModeOriginal,
  ModeWithLiterals as ModeWithLiteralsOriginal,
  SearchStaffMembersResponse as SearchStaffMembersResponseOriginal,
  AggregationData as AggregationDataOriginal,
  ValueAggregationResult as ValueAggregationResultOriginal,
  RangeAggregationResult as RangeAggregationResultOriginal,
  ScalarType as ScalarTypeOriginal,
  ScalarTypeWithLiterals as ScalarTypeWithLiteralsOriginal,
  NestedAggregationResults as NestedAggregationResultsOriginal,
  NestedAggregationResultsResultOneOf as NestedAggregationResultsResultOneOfOriginal,
  AggregationType as AggregationTypeOriginal,
  AggregationTypeWithLiterals as AggregationTypeWithLiteralsOriginal,
  ValueResults as ValueResultsOriginal,
  RangeResults as RangeResultsOriginal,
  AggregationResultsScalarResult as AggregationResultsScalarResultOriginal,
  NestedValueAggregationResult as NestedValueAggregationResultOriginal,
  ValueResult as ValueResultOriginal,
  RangeResult as RangeResultOriginal,
  ScalarResult as ScalarResultOriginal,
  NestedResultValue as NestedResultValueOriginal,
  NestedResultValueResultOneOf as NestedResultValueResultOneOfOriginal,
  Results as ResultsOriginal,
  DateHistogramResult as DateHistogramResultOriginal,
  GroupByValueResults as GroupByValueResultsOriginal,
  DateHistogramResults as DateHistogramResultsOriginal,
  NestedResults as NestedResultsOriginal,
  AggregationResults as AggregationResultsOriginal,
  AggregationResultsResultOneOf as AggregationResultsResultOneOfOriginal,
  DisconnectStaffMemberFromUserRequest as DisconnectStaffMemberFromUserRequestOriginal,
  DisconnectStaffMemberFromUserResponse as DisconnectStaffMemberFromUserResponseOriginal,
  AssignWorkingHoursScheduleRequest as AssignWorkingHoursScheduleRequestOriginal,
  AssignWorkingHoursScheduleResponse as AssignWorkingHoursScheduleResponseOriginal,
  AssignCustomScheduleRequest as AssignCustomScheduleRequestOriginal,
  AssignCustomScheduleResponse as AssignCustomScheduleResponseOriginal,
  BulkUpdateStaffMemberTagsRequest as BulkUpdateStaffMemberTagsRequestOriginal,
  BulkUpdateStaffMemberTagsResponse as BulkUpdateStaffMemberTagsResponseOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkUpdateStaffMemberTagsResult as BulkUpdateStaffMemberTagsResultOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  BulkUpdateStaffMemberTagsByFilterRequest as BulkUpdateStaffMemberTagsByFilterRequestOriginal,
  BulkUpdateStaffMemberTagsByFilterResponse as BulkUpdateStaffMemberTagsByFilterResponseOriginal,
  RestoreStaffRequest as RestoreStaffRequestOriginal,
  RestoreStaffResponse as RestoreStaffResponseOriginal,
  Empty as EmptyOriginal,
  PolicyRemovedFromContributor as PolicyRemovedFromContributorOriginal,
  PolicyUpdatedForContributor as PolicyUpdatedForContributorOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  ScheduleNotification as ScheduleNotificationOriginal,
  ScheduleNotificationEventOneOf as ScheduleNotificationEventOneOfOriginal,
  ScheduleCreated as ScheduleCreatedOriginal,
  Schedule as ScheduleOriginal,
  RecurringInterval as RecurringIntervalOriginal,
  Interval as IntervalOriginal,
  Day as DayOriginal,
  DayWithLiterals as DayWithLiteralsOriginal,
  Frequency as FrequencyOriginal,
  LinkedSchedule as LinkedScheduleOriginal,
  Transparency as TransparencyOriginal,
  TransparencyWithLiterals as TransparencyWithLiteralsOriginal,
  RecurringIntervalType as RecurringIntervalTypeOriginal,
  RecurringIntervalTypeWithLiterals as RecurringIntervalTypeWithLiteralsOriginal,
  Location as LocationOriginal,
  LocationType as LocationTypeOriginal,
  LocationTypeWithLiterals as LocationTypeWithLiteralsOriginal,
  Address as AddressOriginal,
  AddressStreetOneOf as AddressStreetOneOfOriginal,
  StreetAddress as StreetAddressOriginal,
  AddressLocation as AddressLocationOriginal,
  Subdivision as SubdivisionOriginal,
  LocationsLocation as LocationsLocationOriginal,
  LocationStatus as LocationStatusOriginal,
  LocationStatusWithLiterals as LocationStatusWithLiteralsOriginal,
  LocationsLocationType as LocationsLocationTypeOriginal,
  LocationsLocationTypeWithLiterals as LocationsLocationTypeWithLiteralsOriginal,
  LocationsAddress as LocationsAddressOriginal,
  LocationsStreetAddress as LocationsStreetAddressOriginal,
  LocationsAddressLocation as LocationsAddressLocationOriginal,
  BusinessSchedule as BusinessScheduleOriginal,
  TimePeriod as TimePeriodOriginal,
  DayOfWeek as DayOfWeekOriginal,
  DayOfWeekWithLiterals as DayOfWeekWithLiteralsOriginal,
  SpecialHourPeriod as SpecialHourPeriodOriginal,
  Rate as RateOriginal,
  Price as PriceOriginal,
  Availability as AvailabilityOriginal,
  AvailabilityConstraints as AvailabilityConstraintsOriginal,
  SplitInterval as SplitIntervalOriginal,
  Participant as ParticipantOriginal,
  ApprovalStatus as ApprovalStatusOriginal,
  ApprovalStatusWithLiterals as ApprovalStatusWithLiteralsOriginal,
  ExternalCalendarOverrides as ExternalCalendarOverridesOriginal,
  ScheduleStatus as ScheduleStatusOriginal,
  ScheduleStatusWithLiterals as ScheduleStatusWithLiteralsOriginal,
  Version as VersionOriginal,
  ConferenceProvider as ConferenceProviderOriginal,
  CalendarConference as CalendarConferenceOriginal,
  ConferenceType as ConferenceTypeOriginal,
  ConferenceTypeWithLiterals as ConferenceTypeWithLiteralsOriginal,
  ScheduleUpdated as ScheduleUpdatedOriginal,
  RecurringSessionsUpdated as RecurringSessionsUpdatedOriginal,
  Session as SessionOriginal,
  CalendarDateTime as CalendarDateTimeOriginal,
  LocalDateTime as LocalDateTimeOriginal,
  ExternalCalendarInfo as ExternalCalendarInfoOriginal,
  CalendarType as CalendarTypeOriginal,
  CalendarTypeWithLiterals as CalendarTypeWithLiteralsOriginal,
  Status as StatusOriginal,
  StatusWithLiterals as StatusWithLiteralsOriginal,
  SessionType as SessionTypeOriginal,
  SessionTypeWithLiterals as SessionTypeWithLiteralsOriginal,
  SessionVersion as SessionVersionOriginal,
  ParticipantNotification as ParticipantNotificationOriginal,
  ScheduleCancelled as ScheduleCancelledOriginal,
  SessionCreated as SessionCreatedOriginal,
  SessionUpdated as SessionUpdatedOriginal,
  SessionCancelled as SessionCancelledOriginal,
  AvailabilityPolicyUpdated as AvailabilityPolicyUpdatedOriginal,
  AvailabilityPolicy as AvailabilityPolicyOriginal,
  IntervalSplit as IntervalSplitOriginal,
  RecurringSessionSplit as RecurringSessionSplitOriginal,
  ScheduleUnassignedFromUser as ScheduleUnassignedFromUserOriginal,
  MultipleSessionsCreated as MultipleSessionsCreatedOriginal,
  ScheduleWithSessions as ScheduleWithSessionsOriginal,
  SitePropertiesOnScheduleCreation as SitePropertiesOnScheduleCreationOriginal,
  MigrationEvent as MigrationEventOriginal,
  MigrationData as MigrationDataOriginal,
  StaffData as StaffDataOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  BulkUpdateStaffMemberTagsApplicationErrors as BulkUpdateStaffMemberTagsApplicationErrorsOriginal,
  BulkUpdateStaffMemberTagsByFilterApplicationErrors as BulkUpdateStaffMemberTagsByFilterApplicationErrorsOriginal,
} from './bookings-staff-v1-staff-member-staff-members.types.js';
